import store from '../../stores'
import * as fromScenes from '../../stores/ducks/scenes'
import { Scene } from '../../stores/ducks/scenes/Scene'

export default function handleScenes (msg: { doc: Scene }) {
  const { doc } = msg
  store.dispatch(fromScenes.receiveUpdate(doc))
}
